import isExperienceEditor from "@utils/is-experience-editor";

var VCA = VCA || {};

VCA.CoveoScripts = (function ($) {

    var ui = {};

    function cacheUI() {}

    function init() {
        // CoveoRecommendation is for Related KYP articles
        if ($('.CoveoSearchInterface, .CoveoRecommendation').length <= 0) {
            return;
        }
        cacheUI();
        bindCoveoClick();
        //bindCoveoPillSlider();
        toggleSpeciesSelectClass();
        closeSpeciesSelectClass();
        toggleTopicSelectClass();
        closeTopicSelectClass();
        //rebindCoveoPillSlider();
        wrapFiltersLinks();
        //tryUpdateHospitalArticleLinks();
        offClickCloseSelect();
        //pagerRefreshLinks();
        //bindFacetClick();
        //bindSearchClick();
        initArticleLinks();
    }

    function initArticleLinks() {
        var root = document.querySelector('.CoveoSearchInterface');
        if (root == null) {
            root = document.querySelector('.CoveoRecommendation');
        }

        Coveo.$$(root).on("newQuery", function (e, args) {
            let queryBuilder = args.queryBuilder;
        });

        Coveo.$$(root).on("beforeInitialization", function() {
            var originalUrl = document.location;
            var queryStr = document.location.search;
            if(queryStr) {
                var hash = queryStr.indexOf('?') == 0 ? queryStr.replace(/\?/g, "#") : hash;
                var url = originalUrl.pathname + document.location.search + hash;
                history.replaceState(null, '', url);
            }
        });



        Coveo.$$(root).on('buildingQuery', function (e, args) {
            UpdateArticleLinksHost();
            let queryBuilder = args.queryBuilder;
            updateResultPaginationLinks();
            tryUpdateHospitalArticleLinks();
            paginationLinkClick();
            wrapFiltersLinks();
        });

        Coveo.$$(root).on("duringQuery", function (e, args) {
            let argQuery = args.query;
            let argQueryB = args.queryBuilder;
        });


    }

    function paginationLinkClick() {
        setTimeout(() => {
            if ($('.coveo-pager-anchor').length != 0) {
                $('.coveo-pager-anchor').on('click', function(e) {
                    e.preventDefault();
                })
            } else {
                paginationLinkClick();
            }
        }, 1000);
    }

    function updateResultPaginationLinks() {

        setTimeout(() => {
            if ($('.coveo-pager-anchor').length != 0) {
                $('.coveo-pager-anchor').each(function (index, element) {
                    var count = $('.CoveoSearchInterface').attr('data-results-per-page');
                   // console.log('count', count)
                    var pageSet = $(this).html() * count - count;
                    if($(this).is("li")){
                        if($(this).hasClass('coveo-pager-next')){
                            pageSet = $('.coveo-active .coveo-pager-anchor').html() * count;
                        }else{
                            pageSet = $('.coveo-active .coveo-pager-anchor').html() * count - (count * 2);
                        }
                    }

                    var originalUrl = document.location;
                    var hash = document.location.hash;
                    var pageSetUrl;

                    if (hash) {

                        var params = hash.indexOf('#') == 0 ? hash.replace(/#/g, "") : params;
                        var paramsObj = params.split('&').reduce(function (res, item) {
                            var parts = item.split('=');
                            res[parts[0]] = parts[1];
                            return res;
                        }, {});

                        if (paramsObj.first) {
                            paramsObj.first = pageSet;

                            var queryString = Object.keys(paramsObj).map(key => key + '=' + paramsObj[key]).join('&');
                            pageSetUrl = pageSetUrl = originalUrl.pathname + '?' + queryString + '#' + queryString;

                        } else {
                            pageSetUrl = originalUrl.pathname + '?first=' + pageSet + '&' + params + '#first=' + pageSet + '&' + params;
                            var url = new URL(document.location.href);
                            var search_params = url.searchParams;
                            search_params.delete('first');
                            url.search = search_params;
                        }

                    } else {
                        pageSetUrl = originalUrl.pathname + '?first=' + pageSet + '#first=' + pageSet;
                    }

                    if($(this).is("li")) {
                        $(this).find('a').attr('href', pageSetUrl);
                    }else{
                        $(this).attr('href', pageSetUrl);
                    }
                });
            } else {
                updateResultPaginationLinks();
            }
        }, 500);
    }

    function tryUpdateHospitalArticleLinks() {
        setTimeout(() => {
            if ($('.CoveoResultLink').length != 0) {
                var hospitalName = $(this).attr("data-attr-hospitalName");
                if (hospitalName != '') {
                    updateHospitalArticleLinks();
                    pagerRefreshLinks();
                }
            } else {
                tryUpdateHospitalArticleLinks();
            }
        }, 1000);
    }

    function updateHospitalArticleLinks() {
        var updateLink = $('.CoveoResultLink').each(function (index, element) {

            var kypContainer = $('.kypSearchResultContainer');
            var originalUrl = $(this).attr('href');
            var hospitalName = $(this).attr("data-attr-hospitalName");
            if (kypContainer.length == 0) {
                return;
            }
            var hostname = $(location).attr('hostname');
            var url = new URL(originalUrl)
            if (hospitalName != '') {

                hospitalName = "/" + hospitalName;
                var protocol = $(location).attr('protocol');

                if (url.hostname != hostname) {
                    originalUrl = originalUrl.replace(url.hostname, hospitalName);
                }

                var newUrl = originalUrl.replace(protocol + '//', '').replace(hostname, hospitalName).toLowerCase();

                $(this).attr('href', newUrl);
            } else {
                if (url.hostname != hostname) {
                    originalUrl = originalUrl.replace(url.hostname, hostname);
                    $(this).attr('href', originalUrl);
                }
            }
        });
    }

    // KYP articles come with US domain from Coveo so we need to update them for Vca Canada
    function UpdateArticleLinksHost() {
        setTimeout(() => {
            if ($('a.coveo-search-list-item__title, a.CoveoResultLink').length != 0) {
                $('a.coveo-search-list-item__title, a.CoveoResultLink').each(function (index, element) {
                    var hostname = $(location).attr('hostname');
                    var originalUrl = $(this).attr('href');
                    if (originalUrl.startsWith('http')) {
                        var url = new URL(originalUrl)
                        if (url.hostname != hostname) {
                            originalUrl = originalUrl.replace(url.hostname, hostname);
                            $(this).attr('href', originalUrl);
                        }
                    }
                });
            }
        }, 1000);
    }


    function pagerRefreshLinks() {
        setTimeout(() => {
            if ($('.CoveoResultLink').length != 0) {
                var hospitalName = $(this).attr("data-attr-hospitalName");
                if (hospitalName != '') {
                    $(".coveo-pager-anchor").on("click", function (e) {
                        tryUpdateHospitalArticleLinks();
                    });
                }
            } else {
                pagerRefreshLinks();
            }
        }, 1000);
    }

    function bindSearchClick() {
        setTimeout(() => {
            if ($('.CoveoSearchButton').length != 0) {
                $(".CoveoSearchButton").on("click", function (e) {
                    tryUpdateHospitalArticleLinks();
                });
                $('.magic-box-input').find(':input').keyup(function (e) {
                    console.log("search input clicked");
                    console.log(e.key + " + " + e.keyCode);
                    initEnter();
                    if (e.key === 'Enter' || e.keyCode === 13) {
                        e.preventDefault();
                        console.log("search input clicked");
                        console.log(e.key + " + " + e.keyCode);
                        tryUpdateHospitalArticleLinks();
                    }
                });


            } else {
                bindSearchClick();
            }
        }, 1000);

    }

    function bindFacetClick() {
        setTimeout(() => {
            if ($('.coveo-facet-value').length != 0) {
                $(".coveo-facet-values, .coveo-facet-header-eraser").on("click", function (e) {
                    tryUpdateHospitalArticleLinks();
                });
            } else {
                bindFacetClick();
            }
        }, 1000);

    }

    function bindCoveoClick() {
        $(".js-load-more-articles").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var i = $("#coveoaeead5d3").attr("data-results-per-page");
            Coveo.$$("#coveofa66f3ab").coveo("displayMoreResults", parseInt(i))
        });
    }

    /*   function bindCoveoPillSlider() {
          setTimeout(() => { 
              console.log('test');
              var coveoSlider = $('div[data-class="topic"] ul.coveo-facet-values').each(function (index, element) {
                  $(this).addClass('js-coveo-pill-slider' + index + ' dark');
                  var item_length = $('.js-coveo-pill-slider' + index + ' > li').length;
                  console.log(item_length);
                  if(item_length > 1 && !isExperienceEditor) {
                      $('.js-coveo-pill-slider' + index).slick({
                          variableWidth: true,
                          autoplay: false,
                          infinite: false,
                          rows: 0,
                          speed: 100,
                          arrows: true,
                          dots: false,
                          slidesToScroll: 1,
                          outerEdgeLimit: true,
                          draggable: true,
                          swipeToSlide: true
                      });
                  }
              });
          }, 5000);
      } */

    function wrapFiltersLinks() {
        setTimeout(() => {
            var wrapLink = $('div[data-class="topic"] .coveo-facet-value-caption').each(function (index, element) {
                var value = $(this).attr('title');
                value = value.replace(/&\s+/g, '').replace(/\s+/g, '-').toLowerCase();
                var url = "/know-your-pet/topics/" + value;
                $(this).wrap("<a class='new-coveo-link' href='" + url + "'></a>");
            });
        }, 5000);
    }

    function toggleSpeciesSelectClass() {
        $("div[data-class='pet-type']").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).toggleClass('open');
            $("div[data-class='topic']").removeClass('open');
        });
    }

    function closeSpeciesSelectClass() {
        $("div[data-class='pet-type'] .coveo-facet-value-label").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $("div[data-class='pet-type']").removeClass('open');
            $("div[data-class='topic']").removeClass('open');
        });
    }

    function toggleTopicSelectClass() {
        $("div[data-class='topic']").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).toggleClass('open');
            $("div[data-class='pet-type']").removeClass('open');
        });
    }

    function closeTopicSelectClass() {
        $("div[data-class='topic'] .coveo-facet-value-label").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $("div[data-class='pet-type']").removeClass('open');
            $("div[data-class='topic']").removeClass('open');
        });
    }

    function offClickCloseSelect() {
        $(window).on('click', function (e) {
            $("div[data-class='pet-type']").removeClass('open');
            $("div[data-class='topic']").removeClass('open');
        });
    }

    /* function rebindCoveoPillSlider() {
        $(document).on("click", "div[data-class='topic'] li", function (e) {
            console.log('clicked');
            setTimeout(() => { 
                console.log('rebinded');
                $('.js-coveo-pill-slider0').slick('unslick');
                $('.js-coveo-pill-slider0').slick({
                    variableWidth: true,
                    autoplay: false,
                    infinite: false,
                    rows: 0,
                    speed: 100,
                    arrows: true,
                    dots: false,
                    slidesToScroll: 1,
                    outerEdgeLimit: true,
                    draggable: true,
                    swipeToSlide: true
                });
            }, 3000);
        });
    } */

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.CoveoScripts.init();
});